import { handleActions } from 'redux-actions'

import { SessionStatus } from '@tabeeb/enums'

import { updateSessionStatusFilter, resetFilters } from '../../actions'

const defaultState = Object.values(SessionStatus)

export default handleActions(
  {
    [updateSessionStatusFilter](state, action) {
      return action.payload
    },
    [resetFilters](state, action) {
      return defaultState
    },
  },
  defaultState
)
